import { useLoginContext } from "../../../App";
import { useQuery } from '@tanstack/react-query';
import { calculatePlansImpactOnFramework } from "../../../services/b2b-frameworks-apiService";

const usePlansImpact = (frameworkSuite, frameworkId, plansUUIDs) => {
    const { loginData } = useLoginContext();

    const fetchPlansImpact = async () => {
        const { accessToken } = loginData;
        try {
            return await calculatePlansImpactOnFramework(frameworkSuite, frameworkId, plansUUIDs, accessToken);
        } catch (error) {
            console.info('Error fetching plans impact:', error);
            return null;
        }
    };

    const { data: plansImpact, isLoading: isSearching } = useQuery({
        queryKey: ['plansImpact', frameworkSuite, frameworkId, plansUUIDs, loginData.loggedOrganizationUuid],
        queryFn: () => fetchPlansImpact(),
        staleTime: 1000 * 60 * 10, 
        cacheTime: 1000 * 60 * 15, 
    });

    return { plansImpact, isSearching };
};

export default usePlansImpact;